<template>
	<text-input ref="input" :label="label" :originalValue="content" :maxlength="1000000" @input="onInput"></text-input>
</template>

<script>
    import TextInput from './TextInput.vue'
    import moment from 'moment'

	export default {
		name: 'AudioTimeInput',
		components: {
				TextInput
		},
		props: {
			placeholder: { type: String, default: "" },
			readonly: { type: Boolean, default: false },
			label: String,
			labelInfo: String,
			type: { type: String, default: "text" },
			value: { type: [String, Number], default: ''},
			name: String,
			autocomplete: {type:String, default:'on'}
		},
		watch: {
			value: function() {
				this.content = this.formatDuration(this.value)
			}
		},
		data() {
			return {
				// context: Constants.context,
				content: this.formatDuration(this.value)
			}
		},
		mounted(){},
		methods: {
			formatDuration(duration){
				if (!duration || duration.length === 0) {
					return 0;
				}

        return moment(duration).format('mm:ss.SSS');
      },
      onInput(e) {
        const duration = moment('1/1/1970 00:' + e).diff(moment('1/1/1970'));
				this.$emit('input', duration);
			}
		}
	}
</script>
